import HomeOutlinedIcon from '@mui/icons-material/HomeOutlined';
import StorefrontOutlinedIcon from '@mui/icons-material/StorefrontOutlined';
import BarChartOutlinedIcon from '@mui/icons-material/BarChartOutlined';
import PercentOutlinedIcon from '@mui/icons-material/PercentOutlined';
import DescriptionOutlinedIcon from '@mui/icons-material/DescriptionOutlined';
import AttachMoneyOutlinedIcon from '@mui/icons-material/AttachMoneyOutlined';
import AssessmentOutlinedIcon from '@mui/icons-material/AssessmentOutlined';
import { useTranslation } from '../../hooks/useTranslation';
import BaseSidebar, { Item } from './BaseSidebar';

const SidebarSuperAdmin = () => {
  const { t } = useTranslation();

  return (
    <BaseSidebar includeHeight={true}>
      {({ setSelectedSubmenu }) => (
        <>
          <Item
            title={t('sidebar.dashboard')}
            to="/app/dashboard"
            icon={<HomeOutlinedIcon />}
            setSelectedSubmenu={setSelectedSubmenu}
          />

          <Item
            title={t('sidebar.resale')}
            to="/app/resale"
            icon={<StorefrontOutlinedIcon />}
            setSelectedSubmenu={setSelectedSubmenu}
          />

          <Item
            title={t('sidebar.simulator')}
            to="/app/simulators"
            icon={<BarChartOutlinedIcon />}
            setSelectedSubmenu={setSelectedSubmenu}
          />

          <Item
            title={t('sidebar.simulations')}
            to="/app/simulation-adm"
            icon={<PercentOutlinedIcon />}
            setSelectedSubmenu={setSelectedSubmenu}
          />

          <Item
            title={t('sidebar.contracts')}
            to="/app/contratos"
            icon={<DescriptionOutlinedIcon />}
            setSelectedSubmenu={setSelectedSubmenu}
          />

          <Item
            title={t('sidebar.payments')}
            to="/"
            icon={<AttachMoneyOutlinedIcon />}
            setSelectedSubmenu={setSelectedSubmenu}
          />

          <Item
            title={t('sidebar.redScore')}
            to="/app/redscore-adm"
            icon={<AssessmentOutlinedIcon />}
            setSelectedSubmenu={setSelectedSubmenu}
          />
        </>
      )}
    </BaseSidebar>
  );
};

export default SidebarSuperAdmin;
